import type { GridMapboxStyle } from './styles';

export const gridsSection = (style: GridMapboxStyle) => [
  {
    minzoom: 11,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-allow-overlap': false,
      'text-ignore-placement': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'section-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'sec_centers',
  },
  {
    minzoom: 11,
    type: 'line',
    id: 'section-grid',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'sec',
    layout: {
      visibility: 'visible',
    },
  },
];
